import React from "react";

function FeeCpd() {
  return <div></div>;
}

export default FeeCpd;
